import fr from 'facet-rest';
import Sentry from 'Integrations/Sentry';

function getStatusFromError(err) {
  if (err?.status !== undefined) {
    return err.status;
  }

  if (err?.response !== undefined) {
    return err.response.status;
  }

  return undefined;
}

// Returns message to display in snackbar
export const buildErrorMessage = (error, message) => {
  if (error.message?.includes('Request has been terminated') || error.message?.includes('Down for maintenance') || error?.status === 503) {
    return fr.config.onError(error);
  }

  // Log to Sentry
  const status = getStatusFromError(error);
  console.log('Error: ', error); // eslint-disable-line
  Sentry.createSentryErrorLog(error, status);

  // If the error passed in is an array of errors, parse each one and concatinate into one message.
  // Note:  This will assume that the structure of the errors in the array will be { detail:'', ?shortDetail:''},
  //        which from my (Matt Holdefer) inspection of the code seems to be the case.
  if (Array.isArray(message)) {
    return Sentry.createErrorMessage(message);
  } if (message) {
    return message;
  }

  throw new Error('Developer configuration error: No message supplied.');
};

export const displayErrorMessageWithChecks = (error, displayErrorMessageFunc, defaultMessage) => {
  if (error.errors) {
    displayErrorMessageFunc(error, error.errors);
  } else {
    displayErrorMessageFunc(error, defaultMessage);
  }
};
